import FootballStatsCategory from "../../../../stats/football-stats-category";
import FootballState from "../../../../state/football-state";
import StatsRule from "../../../../../common/stats-rule";

export default class PuntNoRecoveryReturnerStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.NoRecoveryKickReturn &&
            play.getPreceedingFragment(fragment, [
                FootballState.OnSide,
                FootballState.FieldGoalBlocked,
                FootballState.PuntBlocked
            ])?.associatedState === FootballState.PuntBlocked &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { recoveredAt } =
            play.getPreviousFragmentOfState(
                fragment,
                FootballState.KickNotRecovered
            ) || {};

        const yards_returned =
            (fragment.returnedAt - recoveredAt) *
            gameContext.getFieldDirectionMultiplier();

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: fragment.returnedBy.teamId,
            playerId: fragment.returnedBy.id,
            driveId: gameContext.currentDriveId,
            fragmentId: fragment.id,
            category: FootballStatsCategory.PUNT_RETURN,
            values: {
                completed: 1,
                attempted: 1,
                yards: yards_returned
            }
        });
    }
}
